// extracted by mini-css-extract-plugin
export default {"card":"CardFrameWithTabs_card__xDFWc","tabRow":"CardFrameWithTabs_tabRow__30dMh","tab":"CardFrameWithTabs_tab__PG0bM","tabActive":"CardFrameWithTabs_tabActive__nsry7"};